import { Set } from "immutable"
import * as React from "react"
import { library } from "../../libraries"
import { ChangeCookiesLink, CookieUpdater } from "./cookiebar"
import { Link } from "./library/link"
import { ApiResult } from "../../../Shared/api/apiTypes"
import { NavigationItem } from "../../../Shared/api/drupal/drupalTypes"
import { errorText, getNavigation, loadingText } from "../../custom_api/api"

interface FooterProps {
  onCookieChange: CookieUpdater
}

interface FooterState {
  readonly items: ApiResult<Set<NavigationItem>>
  readonly secundaryItems: ApiResult<Set<NavigationItem>>
}

export class Footer extends React.Component<FooterProps, FooterState> {
  constructor(props: FooterProps) {
    super(props)

    this.state = {
      items: "loading",
      secundaryItems: "loading",
    }
  }

  componentWillMount() {
    getNavigation("footer").then(res => {
      if (res != "error" && res != "loading") {
        this.setState(s => ({ ...s, items: Set(res) }))
      }
    })

    getNavigation("footer-secondary").then(res => {
      if (res != "error" && res != "loading") {
        this.setState(s => ({ ...s, secundaryItems: Set(res) }))
      }
    })
  }

  render() {
    const p = this.props
    const s = this.state

    return (
      <footer id="a11y-footer" className="footer">
        { library().footerTop() }

        <div className="footer__bottom">
          <div className="footer__section--primary">
            {" "}
            {/* ---- PRIMARY MENU ----- */}
            {s.items == "loading" ? (
              loadingText
            ) : s.items == "error" ? (
              errorText
            ) : (
              <nav className="footer__links container--mg align--center" aria-label="Footer">
                <ul className="footer__links">
                  {s.items.map(link => (
                    <li key={`li-${link.key}`} className="footer__linkitem">
                      <Link
                        key={link.key}
                        url={link.external ? link.absolute : link.relative}
                        external={link.external}
                        className="footer__link"
                      >
                        {link.title}
                      </Link>
                    </li>
                  ))}
                  <li key={`li-reset`} className="footer__linkitem">
                    {ChangeCookiesLink({ onChange: p.onCookieChange })}
                  </li>
                </ul>
              </nav>
            )}
          </div>
        </div>
      </footer>
    )
  }
}

{/* TH: Added to styleguide! */ }

